import { render } from "./SelectCasino.vue?vue&type=template&id=ebdad178&scoped=true"
import script from "./SelectCasino.vue?vue&type=script&lang=js"
export * from "./SelectCasino.vue?vue&type=script&lang=js"

import "./SelectCasino.vue?vue&type=style&index=0&id=ebdad178&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebdad178"]])

export default __exports__